// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ho-z","modalContent":"io-z","header":"jo-z","close":"ko-z"};